import { HttpErrorResponse } from '@angular/common/http';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { Context } from 'src/app/shared/models/context';
import { Employee } from 'src/app/shared/models/domain';
import { CardData, ChartOptions, Graph } from 'src/app/shared/models/insight';
import { AuthService } from 'src/app/shared/services/auth.service';
import { CommonService } from 'src/app/shared/services/common.service';
import { InsightService } from 'src/app/shared/services/insight.service';


@Component({
  selector: 'app-dashboard',
  templateUrl: './dashboard.component.html',
  styleUrls: ['./dashboard.component.scss']
})
export class DashboardComponent implements OnInit {
  public companyCard: CardData;
  public activeUserCard: CardData;
  public employeeCard: CardData;
  public licenseCard: CardData;
  public employeeHrCard: CardData;
  public totalAttendance: CardData;
  public overduePayments: CardData;
  public completedPayments: CardData;
  public totalLeaves: CardData;
  public totalRegularizations: CardData;
  public totalAbsences: CardData;
  public userCard: CardData;
  public context: Context;
  public adminBarGraph: Partial<ChartOptions | any>;
  public hrBarGraph: Partial<ChartOptions | any>;
  public employeeBarGraph: Partial<ChartOptions | any>;
  public hrEmployeeBarGraph: Partial<ChartOptions | any>;
  public c1Loading: boolean = false;
  public c2Loading: boolean = false;
  public c3Loading: boolean = false;
  public c4Loading: boolean = false;
  public c5Loading: boolean = false;
  public c6Loading: boolean = false;
  public holidayLoading: boolean = false;
  public birthdayLoading: boolean = false;
  public newJoineeLoading: boolean = false;
  public regularLoading: boolean = false;
  public leaveLoading: boolean = false;
  public absenceLoading: boolean = false;
  public loading: boolean = true;
  public years: number[] = [];
  public selectedYear: number;
  @ViewChild("chart") chart: DashboardComponent;
  public chartOptions: Partial<ChartOptions>;
  public LineChartOptions: Partial<ChartOptions>;
  public userGraph: Partial<ChartOptions>;
  public employeeGraph: Partial<ChartOptions>;
  public regularGraph: Partial<ChartOptions>;
  public leaveGraph: Partial<ChartOptions>;
  public absenceGraph: Partial<ChartOptions>;
  public joineeCardDetails: CardData[] = [];
  public holidayCardDetails: CardData[] = [];
  public birthdayCardDtails: CardData[] = [];
  public employeeRegular: Partial<ChartOptions>;
  public employeeLeave: Partial<ChartOptions>;
  public employeeAbsence: Partial<ChartOptions>;
  // public companyId: number;
  // public employeeId: number;
  private subscription: any
  private isMultiEvent: boolean = false;
  public emmployees: Employee[]


  constructor(
    private authService: AuthService,
    private insightService: InsightService,
    private toster: ToastrService,
    private commonService: CommonService
  ) {
    this.userGraph = {
      series: [
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        markers: {
          fillColors: ["#00E396", "#775DD0"]
        }
      }
    };
    this.employeeGraph = {
      series: [


      ],
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "straight"
      },
      // title: {
      //   text: "Product Trends by Month",
      //   align: "left"
      // },
      // grid: {
      //   row: {
      //     colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      //     opacity: 0.5
      //   }
      // },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      }
    };


    //hr graph//


    this.leaveGraph = {
      series: [
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        markers: {
          fillColors: ["#00E396", "#775DD0"]
        }
      }
    };


    this.regularGraph = {
      series: [


      ],
      chart: {
        height: 350,
        type: "line",
        zoom: {
          enabled: false
        }
      },
      dataLabels: {
        enabled: false
      },
      stroke: {
        curve: "straight"
      },
      // title: {
      //   text: "Product Trends by Month",
      //   align: "left"
      // },
      // grid: {
      //   row: {
      //     colors: ["#f3f3f3", "transparent"], // takes an array which will be repeated on columns
      //     opacity: 0.5
      //   }
      // },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      }
    };




    this.absenceGraph = {
      series: [
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        markers: {
          fillColors: ["#00E396", "#775DD0"]
        }
      }
    };


    //hr graph -featch with employee//
    this.employeeLeave = {
      series: [
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        markers: {
          fillColors: ["#00E396", "#775DD0"]
        }
      }
    };


    this.employeeRegular = {
      series: [
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        markers: {
          fillColors: ["#00E396", "#775DD0"]
        }
      }
    };
    this.employeeAbsence = {
      series: [
      ],
      chart: {
        type: "bar",
        height: 350
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: "55%",
          // endingShape: "rounded"
        }
      },
      dataLabels: {
        enabled: true
      },
      stroke: {
        show: true,
        width: 2,
        colors: ["transparent"]
      },
      xaxis: {
        categories: [
          "Jan",
          "Feb",
          "Mar",
          "Apr",
          "May",
          "Jun",
          "Jul",
          "Aug",
          "Sep",
          "Oct",
          "Nov",
          "Dec"
        ]
      },
      yaxis: {
        title: {
          text: "$ (thousands)"
        }
      },
      fill: {
        opacity: 1
      },
      tooltip: {
        y: {
          formatter: function (val) {
            return "$ " + val + " thousands";
          }
        }
      },
      legend: {
        show: true,
        showForSingleSeries: true,
        markers: {
          fillColors: ["#00E396", "#775DD0"]
        }
      }
    };


  }






  ngOnInit(): void {
    this.context = this.authService.getContextData() ?? {};
    this.companyCard = { name: 'Total Companies', count: 0 } as CardData;
    this.activeUserCard = { name: 'Active Users', count: 0 } as CardData;
    this.employeeCard = { name: 'Total Employees', count: 0 } as CardData;
    this.userCard = { name: 'Total Users', count: 0 } as CardData;
    this.licenseCard = { name: 'License Expiry' } as CardData;
    this.years = this.commonService.generateYears(5);
    this.selectedYear = new Date().getFullYear();
    this.employeeHrCard = { name: 'Total Employees', count: 0 } as CardData;
    this.totalAttendance = { name: 'Total Attendance', count: 0 } as CardData;
    this.overduePayments = { name: 'Over Due Payments ', count: 0 } as CardData;
    this.completedPayments = { name: 'Completed Payments', count: 0 } as CardData;
    this.totalLeaves = { name: 'Total Leaves', count: 0 } as CardData;
    this.totalRegularizations = { name: 'Total Regularizations ', count: 0 } as CardData;
    this.totalAbsences = { name: 'Total Absences', count: 0 } as CardData;

    this.subscription = this.authService.getContext().subscribe(context => {
      this.context = context;
      if (context.persona && !this.isMultiEvent) {
        this.loadInsights(context.persona)
        // this.isMultiEvent = true;
        // context.persona !== 'ADMIN' ? this.companyId = context.companyId : null;
        // switch (context.persona) {
        //   case 'ADMIN': {
        //     this.getAdminDashboard();
        //     this.getCompanyEmployeeGraph();
        //     break;
        //   }
        //   case 'CLIENT': {


        //     this.getClientDashboard();
        //     break;
        //   }
        //   case 'HR': {
        //     this.getHrDashboard();
        //     break;
        //   }
        //   case 'EMPLOYEE': {
        //     this.getEmployeeDashboard(this.context.employeeId);
        //     break;
        //   }
        //   case 'ACCOUNTANT': {
        //     this.getAccountantDashboard();
        //     break;
        //   }
        //   default: break;
        // }
        // setTimeout(() => {
        //   this.isMultiEvent = false;
        // }, 1000);
      }
      // if (this.context.persona === 'HR') {
      //   if(context.companyId){
      //     this.companyService.getEmployees(this.context.companyId).subscribe({
      //       next: (emmployees: Employee[]) => {
      //         this.emmployees = emmployees
      //       },
      //       error: (error: HttpErrorResponse) => {
      //         this.toster.error(error?.error.name || error.message);
      //       }
      //     })
      //   }


      // }
    });


    this.adminBarGraph = {
      series: [{
        name: 'Users',
        type: 'column',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }, {
        name: 'Employees',
        type: 'line',
        data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
      }],
      chart: {
        foreColor: '#9ba7b2',
        height: 400,
        type: 'line',
        zoom: {
          enabled: false
        },
        toolbar: {
          show: true
        },
      },
      stroke: {
        width: [0, 4]
      },
      plotOptions: {
        bar: {
          horizontal: true,
          columnWidth: '25%',
          endingShape: 'rounded'
        }
      },
      colors: ["#2a97ce", "#e38638"],
      title: {
        text: 'Workforce Overview'
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1]
      },
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      xaxis: {
        type: 'date'
      },
      yaxis: [{
        title: {
          text: 'Users',
        },
      },
      {
        opposite: true,
        title: {
          text: 'Employees'
        }
      }],
      noData: {
        text: 'No Data',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '14px',
          fontFamily: undefined
        }
      }
    };

    this.hrBarGraph = {
      series: [
        {
          name: 'Leave',
          type: 'column',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: 'Regular',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: 'Absence',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
      ],
      chart: {
        foreColor: '#9ba7b2',
        height: 400,
        type: 'line',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
        },
      },
      stroke: {
        width: [0, 4, 4],
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '25%',
          endingShape: 'rounded',
        },
      },
      colors: ["#2a97ce", "#e38638", "#ff4560"],
      title: {
        text: 'Attendance Trends',
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1, 2],
      },
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      xaxis: {
        type: 'category',
      },
      yaxis: [
        {
          title: {
            text: 'Attendance',
          },
        },
      ],
      noData: {
        text: 'No Data',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '14px',
          fontFamily: undefined,
        },
      },
    };

    this.hrEmployeeBarGraph = {
      series: [
        {
          name: 'Leave',
          type: 'column',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: 'Regular',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: 'Absence',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
      ],
      chart: {
        foreColor: '#9ba7b2',
        height: 400,
        type: 'line',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
        },
      },
      stroke: {
        width: [0, 4, 4],
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '25%',
          endingShape: 'rounded',
        },
      },
      colors: ["#2a97ce", "#e38638", "#ff4560"],
      title: {
        text: 'My Attendance Summary',
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1, 2],
      },
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      xaxis: {
        type: 'category',
      },
      yaxis: [
        {
          title: {
            text: 'Attendance',
          },
        },
      ],
      noData: {
        text: 'No Data',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '14px',
          fontFamily: undefined,
        },
      },
    };

    this.employeeBarGraph = {
      series: [
        {
          name: 'Leave',
          type: 'column',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: 'Regular',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
        {
          name: 'Absence',
          type: 'line',
          data: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0]
        },
      ],
      chart: {
        foreColor: '#9ba7b2',
        height: 400,
        type: 'line',
        zoom: {
          enabled: false,
        },
        toolbar: {
          show: true,
        },
      },
      stroke: {
        width: [0, 4, 4],
      },
      plotOptions: {
        bar: {
          horizontal: false,
          columnWidth: '25%',
          endingShape: 'rounded',
        },
      },
      colors: ["#2a97ce", "#e38638", "#ff4560"],
      title: {
        text: 'Attendance Trends',
      },
      dataLabels: {
        enabled: true,
        enabledOnSeries: [1, 2],
      },
      labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'June', 'July', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
      xaxis: {
        type: 'category',
      },
      yaxis: [
        {
          title: {
            text: 'Attendance',
          },
        },
      ],
      noData: {
        text: 'No Data',
        align: 'center',
        verticalAlign: 'middle',
        offsetX: 0,
        offsetY: 0,
        style: {
          color: undefined,
          fontSize: '14px',
          fontFamily: undefined,
        },
      },
    };
  }
  private getHrDashboard() {
    // if (this.companyId) {
    //   this.getCompanyEmployeeGraph();
    //   this.getEmployeeData();
    //   //set this when a employee is selected
    //   this.insightService.getRegular(this.companyId).subscribe({
    //     next: (graph: Graph) => {
    //       this.regularGraph.series = graph.graphData;
    //     },
    //     error: (error: HttpErrorResponse) => {
    //       this.toster.error(error?.error?.name || error.message);
    //     }
    //   })


    //   this.insightService.getLeave(this.companyId).subscribe({
    //     next: (graph: Graph) => {
    //       this.leaveGraph.series = graph.graphData;
    //     },
    //     error: (error: HttpErrorResponse) => {
    //       this.toster.error(error?.error?.name || error.message);
    //     }
    //   })


    //   this.insightService.getAbsence(this.companyId).subscribe({
    //     next: (graph: Graph) => {
    //       this.absenceGraph.series = graph.graphData;
    //     },
    //     error: (error: HttpErrorResponse) => {
    //       this.toster.error(error?.error?.name || error.message);
    //     }
    //   })
    // }
  }


  private getEmployeeData() {
    // if (this.companyId) {
    //   this.insightService.getJoinee(this.companyId).subscribe({
    //     next: (card: CardData[]) => {
    //       this.joineeCardDetails = card;
    //     },
    //     error: (error: HttpErrorResponse) => {
    //       this.toster.error(error?.error.name || error.message);
    //     }
    //   })


    //   this.insightService.getHoliday(this.companyId).subscribe({
    //     next: (card: CardData[]) => {
    //       this.holidayCardDetails = card;
    //     },
    //     error: (error: HttpErrorResponse) => {
    //       this.toster.error(error?.error.name || error.message);
    //     }
    //   })


    //   this.insightService.getBirthday(this.companyId).subscribe({
    //     next: (card: CardData[]) => {
    //       this.birthdayCardDtails = card;
    //     },
    //     error: (error: HttpErrorResponse) => {
    //       this.toster.error(error?.error.name || error.message);
    //     }
    //   })
    // }
  }


  // public getEmployeeDashboard(employeeId: number) {
  //   this.employeeId = employeeId;
  //   // this.getEmployeeData();
  //   if (this.employeeId) {
  //     this.insightService.getEmployeeRegular(this.employeeId).subscribe({
  //       next: (graph: Graph) => {
  //         this.employeeRegular.series = graph.graphData;
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.toster.error(error?.error?.name || error.message);
  //       }
  //     })


  //     this.insightService.getEmployeeLeave(this.employeeId).subscribe({
  //       next: (graph: Graph) => {
  //         this.employeeLeave.series = graph.graphData;
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.toster.error(error?.error?.name || error.message);
  //       }
  //     })


  //     this.insightService.getEmployeeAbsence(this.employeeId).subscribe({
  //       next: (graph: Graph) => {
  //         this.employeeAbsence.series = graph.graphData;
  //       },
  //       error: (error: HttpErrorResponse) => {
  //         this.toster.error(error?.error?.name || error.message);
  //       }
  //     })
  //   }


  // }
  ngOnDestroy() {
    this.subscription?.unsubscribe();
  }

  private loadInsights(persona: string) {
    switch (persona) {
      case 'ADMIN':
        this.getTotalCompaniesCount();
        this.getActiveUsersCount(this.context.companyId);
        this.getExpiredLicenseCount();
        this.getTotalUsersCount(this.context.companyId);
        this.getUserInsightMertics();
        this.getEmployeeInsightMertics();
        break;
      case 'CLIENT':
        this.getAdminActiveUsersCount(this.context.companyId);
        this.getTotalUsersCount(this.context.companyId);
        this.getTotalEmployeesCount(this.context.companyId);
        this.getUserInsightMertics();
        this.getEmployeeInsightMertics();
      case 'HR':
        this.getHolidays();
        this.getBirthdays();
        this.getNewJoiness();
        this.getTotalHrEmployeeCount();
        this.getTotalAttendanceCount();
        this.getTotalOverDueCount();
        this.getTotalCompletePaymentCount();
        this.getAbsenceInsightMertics();
        this.getLeaveInsightMertics();
        this.getRegularInsightMertics();
        if (this.context.employeeId) {
          this.getHrEmployeeLeaveInsightMertics(this.context.employeeId);
          this.getHrEmployeeRegularInsightMertics(this.context.employeeId);
          this.getHrEmployeeAbsenceInsightMertics(this.context.employeeId);
          this.getTotalLeaveCount(this.context.employeeId);
          this.getTotalRegularCount(this.context.employeeId);
          this.getTotalAbsenceCount(this.context.employeeId);
        }
        break;
      case 'EMPLOYEE':
        this.getEmployeeHolidays();
        this.getEmployeeNewJoiness();
        this.getEmployeeBirthdays();
        if (this.context.employeeId) {
          this.getTotalLeaveCount(this.context.employeeId);
          this.getTotalRegularCount(this.context.employeeId);
          this.getTotalAbsenceCount(this.context.employeeId);
          this.getEmployeeAbsence(this.context.employeeId);
          this.getEmployeeLeave(this.context.employeeId);
          this.getEmployeeRegular(this.context.employeeId);
        }
      default:
        break;
    }
  }

  public getMetrisOnChange() {
    this.getUserInsightMertics();
    this.getEmployeeInsightMertics();
  }

  public getHrMetrisOnChange() {
    this.getAbsenceInsightMertics();
    this.getLeaveInsightMertics();
    this.getRegularInsightMertics();
    if (this.context.employeeId) {
      this.getHrEmployeeLeaveInsightMertics(this.context.employeeId);
      this.getHrEmployeeRegularInsightMertics(this.context.employeeId);
      this.getHrEmployeeAbsenceInsightMertics(this.context.employeeId);
    }
  }

  public getEmployeeMetrisOnChange() {
    if (this.context.employeeId) {
      this.getEmployeeAbsence(this.context.employeeId);
      this.getEmployeeLeave(this.context.employeeId);
      this.getEmployeeRegular(this.context.employeeId);
    }
  }

  private getTotalCompaniesCount() {
    this.c1Loading = true;
    this.insightService.getTotalCompaniesCount().subscribe({
      next: (companyCard: CardData) => {
        companyCard.name = 'Total Companies';//Modify api response
        this.companyCard = companyCard;
        this.c1Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c1Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getActiveUsersCount(companyId?: number) {
    this.c2Loading = true;
    this.insightService.getActiveUsersCount(companyId).subscribe({
      next: (activeUserCard: CardData) => {
        this.activeUserCard = activeUserCard;
        this.c2Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c2Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getAdminActiveUsersCount(companyId?: number) {
    this.c2Loading = true;
    this.insightService.getAdminActiveUsersCount(companyId).subscribe({
      next: (activeUserCard: CardData) => {
        this.activeUserCard = activeUserCard;
        this.c2Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c2Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalEmployeesCount(companyId?: number) {
    this.c3Loading = true;
    this.insightService.getTotalEmployeesCount(companyId).subscribe({
      next: (employeeCard: CardData) => {
        this.employeeCard = employeeCard;
        this.c3Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c3Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalUsersCount(companyId?: number) {
    this.c4Loading = true;
    this.insightService.getTotalUserCount(companyId).subscribe({
      next: (userCard: CardData) => {
        this.userCard = userCard;
        this.c4Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c4Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getExpiredLicenseCount() {
    this.c3Loading = true;
    this.insightService.getExpiredLicenseCount().subscribe({
      next: (license: CardData) => {
        this.licenseCard = license;
        this.c3Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c3Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getUserInsightMertics() {
    this.c5Loading = true;
    this.insightService.getUserInsightMetrics(this.context.companyId, this.selectedYear).subscribe({
      next: (userInsight: Graph) => {
        const insight = userInsight?.graphData[0] ?? null;
        this.adminBarGraph.series[0] = { name: insight.name, data: insight.data, type: 'column' };
        this.adminBarGraph.series = [... this.adminBarGraph.series];
        this.c5Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c5Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getEmployeeInsightMertics() {
    this.c6Loading = true;
    this.insightService.getEmployeeInsightMetrics(this.context.companyId, this.selectedYear).subscribe({
      next: (userInsight: Graph) => {
        const insight = userInsight?.graphData[0] ?? null;
        this.adminBarGraph.series[1] = { name: insight.name, data: insight.data, type: 'line' };
        this.adminBarGraph.series = [... this.adminBarGraph.series];
        this.c6Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c6Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  // HR//
  private getHolidays() {
    this.holidayLoading = true;
    this.insightService.getHolidays().subscribe({
      next: (holidays: CardData[]) => {
        this.holidayCardDetails = holidays.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
        this.holidayLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.holidayLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getBirthdays() {
    this.birthdayLoading = true;
    this.insightService.getBirthdays().subscribe({
      next: (birthdays: CardData[]) => {
        this.birthdayCardDtails = birthdays.sort((a, b) => new Date(a.date).getMonth() - new Date(b.date).getMonth() || new Date(a.date).getDate() - new Date(b.date).getDate());
        this.birthdayLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.birthdayLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getNewJoiness() {
    this.newJoineeLoading = true;
    this.insightService.getJoinees().subscribe({
      next: (newJoiness: CardData[]) => {
        this.joineeCardDetails = newJoiness;
        this.newJoineeLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.newJoineeLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getHrEmployeeRegularInsightMertics(employee?: number) {
    this.regularLoading = true;
    this.insightService.getHrEmployeeRegularInsightMetrics(employee, this.selectedYear).subscribe({
      next: (regularInsight: Graph) => {
        const insight = regularInsight?.graphData[0] ?? null;
        if (insight) {
          this.hrEmployeeBarGraph.series[1] = { name: insight.name, data: insight.data, type: 'line' }; // Regular at series[1]
          this.hrEmployeeBarGraph.series = [...this.hrEmployeeBarGraph.series]; // Trigger change detection
        }
        this.regularLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.regularLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getHrEmployeeLeaveInsightMertics(employee?: number) {
    this.leaveLoading = true;
    this.insightService.getHrEmployeeLeaveInsightMetrics(employee, this.selectedYear).subscribe({
      next: (leaveInsight: Graph) => {
        const insight = leaveInsight?.graphData[0] ?? null;
        if (insight) {
          this.hrEmployeeBarGraph.series[0] = { name: insight.name, data: insight.data, type: 'column' }; // Leave at series[0]
          this.hrEmployeeBarGraph.series = [...this.hrEmployeeBarGraph.series]; // Trigger change detection
        }
        this.leaveLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.leaveLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getHrEmployeeAbsenceInsightMertics(employee?: number) {
    this.absenceLoading = true;
    this.insightService.getHrEmployeeAbsenceInsightMetrics(employee, this.selectedYear).subscribe({
      next: (absenceInsight: Graph) => {
        const insight = absenceInsight?.graphData[0] ?? null;
        if (insight) {
          this.hrEmployeeBarGraph.series[2] = { name: insight.name, data: insight.data, type: 'line' }; // Absence at series[2]
          this.hrEmployeeBarGraph.series = [...this.hrEmployeeBarGraph.series]; // Trigger change detection
        }
        this.absenceLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.absenceLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getRegularInsightMertics() {
    this.regularLoading = true;
    this.insightService.getRegularInsightMetrics(this.selectedYear).subscribe({
      next: (regularInsight: Graph) => {
        const insight = regularInsight?.graphData[0] ?? null;
        if (insight) {
          this.hrBarGraph.series[1] = { name: insight.name, data: insight.data, type: 'line' }; // Regular at series[1]
          this.hrBarGraph.series = [...this.hrBarGraph.series]; // Trigger change detection
        }
        this.regularLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.regularLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getLeaveInsightMertics() {
    this.leaveLoading = true;
    this.insightService.getLeaveInsightMetrics(this.selectedYear).subscribe({
      next: (leaveInsight: Graph) => {
        const insight = leaveInsight?.graphData[0] ?? null;
        if (insight) {
          this.hrBarGraph.series[0] = { name: insight.name, data: insight.data, type: 'column' }; // Leave at series[0]
          this.hrBarGraph.series = [...this.hrBarGraph.series]; // Trigger change detection
        }
        this.leaveLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.leaveLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getAbsenceInsightMertics() {
    this.absenceLoading = true;
    this.insightService.getAbsenceInsightMetrics(this.selectedYear).subscribe({
      next: (absenceInsight: Graph) => {
        const insight = absenceInsight?.graphData[0] ?? null;
        if (insight) {
          this.hrBarGraph.series[2] = { name: insight.name, data: insight.data, type: 'line' }; // Absence at series[2]
          this.hrBarGraph.series = [...this.hrBarGraph.series]; // Trigger change detection
        }
        this.absenceLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.absenceLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalAttendanceCount() {
    this.c2Loading = true;
    this.insightService.getTotalAttandanceCount().subscribe({
      next: (totalAttendance: CardData) => {
        this.totalAttendance = totalAttendance;
        this.c2Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c2Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalOverDueCount() {
    this.c3Loading = true;
    this.insightService.getTotalOverDuePaymentCount().subscribe({
      next: (overduePayments: CardData) => {
        this.overduePayments = overduePayments;
        this.c3Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c3Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalCompletePaymentCount() {
    this.c4Loading = true;
    this.insightService.getTotalCompletedPaymentCount().subscribe({
      next: (completedPayments: CardData) => {
        this.completedPayments = completedPayments;
        this.c4Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c4Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalHrEmployeeCount() {
    this.c1Loading = true;
    this.insightService.getTotalEmployeeCount().subscribe({
      next: (employeeHrCard: CardData) => {
        this.employeeHrCard = employeeHrCard;
        this.c1Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c1Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  // EMPLOYEE//
  private getTotalLeaveCount(employeeId: number) {
    this.c1Loading = true;
    this.insightService.getTotalLeavesCount(employeeId).subscribe({
      next: (totalLeaves: CardData) => {
        this.totalLeaves = totalLeaves;
        this.c1Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c1Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalRegularCount(employeeId: number) {
    this.c2Loading = true;
    this.insightService.getTotalRegularCount(employeeId).subscribe({
      next: (totalRegularizations: CardData) => {
        this.totalRegularizations = totalRegularizations;
        this.c2Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c2Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getTotalAbsenceCount(employeeId: number) {
    this.c3Loading = true;
    this.insightService.getTotalAbsenceCount(employeeId).subscribe({
      next: (totalAbsences: CardData) => {
        this.totalAbsences = totalAbsences;
        this.c3Loading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.c3Loading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getEmployeeHolidays() {
    this.holidayLoading = true;
    this.insightService.getEmployeeHolidays().subscribe({
      next: (holidays: CardData[]) => {
        this.holidayCardDetails = holidays.sort((a, b) => new Date(a.date).getTime() - new Date(b.date).getTime());
        this.holidayLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.holidayLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getEmployeeBirthdays() {
    this.birthdayLoading = true;
    this.insightService.getEmployeeBirthdays().subscribe({
      next: (birthdays: CardData[]) => {
        this.birthdayCardDtails = birthdays.sort((a, b) => new Date(a.date).getMonth() - new Date(b.date).getMonth() || new Date(a.date).getDate() - new Date(b.date).getDate());
        this.birthdayLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.birthdayLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getEmployeeNewJoiness() {
    this.newJoineeLoading = true;
    this.insightService.getEmployeeJoinees().subscribe({
      next: (newJoiness: CardData[]) => {
        this.joineeCardDetails = newJoiness;
        this.newJoineeLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.newJoineeLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getEmployeeRegular(employee: number) {
    this.regularLoading = true;
    this.insightService.getEmployeeRegular(employee, this.selectedYear).subscribe({
      next: (regularInsight: Graph) => {
        const insight = regularInsight?.graphData[0] ?? null;
        if (insight) {
          this.employeeBarGraph.series[1] = { name: insight.name, data: insight.data, type: 'line' }; // Regular at series[1]
          this.employeeBarGraph.series = [...this.employeeBarGraph.series]; // Trigger change detection
        }
        this.regularLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.regularLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getEmployeeLeave(employee: number) {
    this.leaveLoading = true;
    this.insightService.getEmployeeLeave(employee, this.selectedYear).subscribe({
      next: (leaveInsight: Graph) => {
        const insight = leaveInsight?.graphData[0] ?? null;
        if (insight) {
          this.employeeBarGraph.series[0] = { name: insight.name, data: insight.data, type: 'column' }; // Leave at series[0]
          this.employeeBarGraph.series = [...this.employeeBarGraph.series]; // Trigger change detection
        }
        this.leaveLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.leaveLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }

  private getEmployeeAbsence(emmployee: number) {
    this.absenceLoading = true;
    this.insightService.getEmployeeAbsence(emmployee, this.selectedYear).subscribe({
      next: (absenceInsight: Graph) => {
        const insight = absenceInsight?.graphData[0] ?? null;
        if (insight) {
          this.employeeBarGraph.series[2] = { name: insight.name, data: insight.data, type: 'line' }; // Absence at series[2]
          this.employeeBarGraph.series = [...this.employeeBarGraph.series]; // Trigger change detection
        }
        this.absenceLoading = false;
      },
      error: (error: HttpErrorResponse) => {
        this.absenceLoading = false;
        this.toster.error(error?.error?.name || error.message);
      }
    });
  }
}
